
import { Component, Mixins } from 'vue-property-decorator';
import ResponsivenessMixin from '@/features/common/mixins/responsivenessMixin';

@Component
export default class HistoryFilterButtons extends Mixins(ResponsivenessMixin) {
  get btnClasses(): string[] {
    return this.isTablet ? ['ss-btn-secondary', 'ss-btn-secondary--md'] : ['ss-btn-secondary', 'ss-btn-secondary--sm'];
  }
}
